import { Grid2 as Grid, Typography } from '@mui/material';
import { ReactNode } from 'react';
import ControlsZone from './ControlsZone';
import { ControlZoneSource, ProjectSectionAccordion } from 'domain/shared/newProject';
import { TextFieldWithPrefix } from 'framework/ui/field';
import { EmployeeLinkFieldWithNameLoading, useIsEmployeeProfileAccessible } from 'domain/shared/employee';
import { KeyPersonIcon } from 'framework/ui/mui-builder';

type BaseControlProps = {
  title: string;
  controlResponsible?: string;
  zone?: ControlZoneSource;
  healthchecks: ReactNode;
  sections?: ReactNode;
};
const BaseControl = ({ title, zone, controlResponsible, healthchecks, sections }: BaseControlProps) => {
  const hasSections = !!sections;
  const isResponsibleAccessible = useIsEmployeeProfileAccessible(controlResponsible);

  return (
    <ProjectSectionAccordion
      defaultExpanded
      title={
        <Grid container direction="row" alignItems="center" width="100%">
          <Grid size={hasSections ? 3.7 : 5} pl={1}>
            <Typography variant="h4" color="primary">
              {title}
            </Typography>
          </Grid>
          {controlResponsible ? (
            <Grid size="grow">
              <TextFieldWithPrefix
                tooltipProps={{
                  title: 'Responsible for the control plane',
                  children: (
                    <div>
                      <KeyPersonIcon
                        sx={{
                          fontSize: 18,
                          opacity: '0.8',
                        }}
                      />
                    </div>
                  ),
                }}
                boxSx={{ a: { color: 'text.secondary' } }}
                value={
                  <EmployeeLinkFieldWithNameLoading
                    ignoredNameParts={['middleName', 'maidenName']}
                    externalId={controlResponsible}
                    isLink={isResponsibleAccessible}
                  />
                }
              />
            </Grid>
          ) : (
            <Grid size="grow" />
          )}
          <Grid size="auto">
            <ControlsZone zone={zone} />
          </Grid>
        </Grid>
      }
    >
      <Grid container direction="row" size={12}>
        <Grid size={hasSections ? { lg: 5, md: 12, xs: 12 } : 12}>{healthchecks}</Grid>
        {hasSections && <Grid size={{ lg: 7, md: 12, xs: 12 }}>{sections}</Grid>}
      </Grid>
    </ProjectSectionAccordion>
  );
};
export default BaseControl;
